// extracted by mini-css-extract-plugin
export default {"containerApp":"App_containerApp__02hfB","loading":"App_loading__Z10nZ","girar":"App_girar__6KsF7"};